import {Injectable} from '@angular/core';
import {ApiVisa, BaseApiTemplateService, BasicApiResponseModel, Core2Config} from '../shared';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import { GenericDocContainerModel, GenericDocPgwTxnContainerModel, CpCommercePgwGenerateRefNoRequestModel, PointPurchaseRequest, PaymentTxnStatusRefNoResponseModel} from '../../../../../models';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({providedIn: 'root'})

export class CpCommerceInternalShoppingCartService extends BaseApiTemplateService<any> {
  static readonly CPCOMMERCE_INTERNAL_SHOPPING_CART_SUB_PATH = 'cp-commerce/internal-shopping-carts';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'cp-commerce/internal-shopping-carts';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + CpCommerceInternalShoppingCartService.CPCOMMERCE_INTERNAL_SHOPPING_CART_SUB_PATH;
    this.endpoint_path_public_url = Core2Config.TENANT_DOMAIN_URL_PREFIX + CpCommerceInternalShoppingCartService.CPCOMMERCE_INTERNAL_SHOPPING_CART_SUB_PATH + '/' + BaseApiPublicLoginTemplateService.LOGIN_EP;
    this.httpClient = http;
  }

  generatePaymentReferenceNumber(request: CpCommercePgwGenerateRefNoRequestModel, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<GenericDocPgwTxnContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/generate-payment-reference';
    return this.httpClient.post<BasicApiResponseModel<GenericDocPgwTxnContainerModel>>(
      url,
      request,
      this.getHttpHeader(apiVisa)
    );
  }

  generatePaymentReferenceNumberLoginEp(request: CpCommercePgwGenerateRefNoRequestModel, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<GenericDocPgwTxnContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/generate-payment-reference/login-ep';
    return this.httpClient.post<BasicApiResponseModel<GenericDocPgwTxnContainerModel>>(
      url,
      request,
      this.getHttpHeader(apiVisa)
    );
  }

  productCouponItemPurchase(request: PointPurchaseRequest, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<any>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/backoffice-ep/purchase-by-points';
    return this.httpClient.post<BasicApiResponseModel<any>>(
      url,
      request,
      this.getHttpHeader(apiVisa)
    );
  }

  shoppingCartToSalesOrder(shoppingCart: GenericDocContainerModel, apiVisa: ApiVisa, platform?: string): Observable<BasicApiResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    let url = this.apiUrl + '/convert-to-sales-order';
    if (platform) {
      url = this.apiUrl + '/convert-to-sales-order?platform=' + platform;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      url,
      shoppingCart,
      this.getHttpHeader(apiVisa)
    );
  }

  getPaymentResponseTxnStatusByMerchantCodeRefNoLoginEp(merchantCode: string, merchantRefNo: string, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<string>> {
    if (this.endpoint_path_public_url && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path_public_url;
    }
    const url = this.apiUrl + '/payment-response-txn-status-by-merchant-code-ref-no?merchantCode=' + merchantCode + '&merchantRefNo='  + merchantRefNo;
    return this.httpClient.get<BasicApiResponseModel<string>>(url, this.getHttpHeader(apiVisa));
  }

  getPaymentResponseTxnStatusRefNoByMerchantCodeRefNoLoginEp(merchantCode: string, merchantRefNo: string, apiVisa: ApiVisa) : Observable<BasicApiResponseModel<PaymentTxnStatusRefNoResponseModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    const url = this.apiUrl + '/payment-response-txn-by-merchant-code-ref-no/login-ep?merchantCode=' + merchantCode + '&merchantRefNo='  + merchantRefNo;
    return this.httpClient.get<BasicApiResponseModel<PaymentTxnStatusRefNoResponseModel>>(url, this.getHttpHeader(apiVisa));
  }

  shoppingCartToSalesOrderLoginEntityEp(shoppingCart: GenericDocContainerModel, apiVisa: ApiVisa, platform?: string): Observable<BasicApiResponseModel<GenericDocContainerModel>> {
    if (this.endpoint_path && apiVisa.api_domain_url) {
      this.apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }
    let url = this.apiUrl + '/convert-to-sales-order/login-entity-ep';
    if (platform) {
      url = this.apiUrl + '/convert-to-sales-order/login-entity-ep?platform=' + platform;
    }
    return this.httpClient.post<BasicApiResponseModel<GenericDocContainerModel>>(
      url,
      shoppingCart,
      this.getHttpHeader(apiVisa)
    );
  }
}
